export const getCustomerLabel = (option) => `${option.customerReference} (${option.customerName})`;

export const getExpiredCustomerLabel = (option, expiredTerm: string) =>
  `${getCustomerLabel(option)} - ${expiredTerm}`;
